import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import EditForm from '../managed-product/EditForm';
import Heading from '../common/Heading';
import BZAPIService from '../../services/BZAPIService';
import Loader from '../common/Loader';

export default function ManagedProductEdit() {
  const { vendorId } = useParams();
  const [vendor, setVendor] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function onLoad() {
      try {
        console.log('xxisloading');
        const vendor = await BZAPIService.getVendor(vendorId);
        console.log('vendor', vendor);
        setVendor(vendor);
        setIsLoading(false);
      } catch (e) {
        console.log('e', e);
      }
    }

    onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (isLoading) return <Loader text="Loading product..." />;
  const { name } = vendor.vendorData;

  return (
    <>
      <Heading
        title={`${name?.replace('Systems', 'Networks')} Managed Product`}
        subtitle={`Specify configuration details`}
        className="mb-4 mt-3"
        icon="edit"
      />
      <EditForm
        vendorLabel={name}
        vendorId={vendorId}
        vendorBugCategoryOptions={vendor?.vendorData?.vendorBugCategories ? vendor.vendorData.vendorBugCategories : []}
        vendorBugTypeOptions={vendor?.vendorData?.vendorBugTypes ? vendor.vendorData.vendorBugTypes : []}
        includedComponents={vendor?.vendorData?.vendorBugComponents ? vendor.vendorData.vendorBugComponents : []}
      />
    </>
  );
}

ManagedProductEdit.propTypes = {
  forms: PropTypes.func,
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string
};
